import { Component } from "@angular/core";

@Component({
    selector: "icon-info-modal",
    templateUrl: "./info_modal.svg",
    standalone: false
})
export class InfoModalIconComponent {}
